import { tokens } from "../tokens";

export const ms = {
  [tokens.common.languageChanged]: "Bahasa ditukar",
  [tokens.nav.auth]: "Pengesahan",
  [tokens.nav.create]: "Tambah",
  [tokens.nav.dashboard]: "Dashboard",
  [tokens.nav.details]: "Butiran",
  [tokens.nav.edit]: "Kemaskini",
  [tokens.nav.error]: "Ralat",
  [tokens.nav.files]: "Fail",
  [tokens.nav.forgotPassword]: "Terlupa Kata Laluan",
  [tokens.nav.list]: "Senarai",
  [tokens.nav.login]: "Log Masuk",
  [tokens.nav.mail]: "Mel",
  [tokens.nav.overview]: "Gambaran Keseluruhan",
  [tokens.nav.profile]: "Profil",
  [tokens.nav.register]: "Daftar",
  [tokens.nav.resetPassword]: "Reset Kata Laluan",
  [tokens.nav.editSite]: "Kemaskini Site",
  [tokens.nav.editMeter]: "Kemaskini Meter",
  [tokens.nav.readings]: "Bacaan Harian",
  [tokens.nav.graph]: "Paparan Graf",
  [tokens.nav.dailyCons]: "Penggunaan Harian",
  [tokens.nav.monthlyCons]: "Pengunaan Bulanan",
  [tokens.nav.sites]: "Tapak-tapak",
  [tokens.nav.settings]: "Tetapan",
  [tokens.nav.jobSummary]: "Ringkasan Kerja",
  [tokens.nav.logViewer]: "Paparan Log",
  [tokens.nav.logout]: "Log Keluar",
  [tokens.nav.loggerType]: "Jenis Logger",
  [tokens.nav.telemetry]: "Telemetri",
  [tokens.nav.administration]: "Pentadbiran",
  [tokens.nav.roles]: "Peranan",
  [tokens.nav.users]: "Pengguna",
  [tokens.nav.changePassword]: "Tukar Kata Laluan",
  [tokens.nav.audit]: "Jejak Audit",
  [tokens.nav.stations]: "Stesen",
  [tokens.nav.rtus]: "RTU",
  [tokens.nav.waterQuality]: "Kualiti Air",
  [tokens.nav.hydrology]: "Hidrologi",
  [tokens.nav.alarms]: "Penggera",
  [tokens.nav.reports]: "Laporan",
  [tokens.nav.inSituSampling]: "Persampelan In-Situ",
  [tokens.msg.getSupport]:
    "Jika anda mempunyai sebarang masalah sila hubungi kami di ",
  [tokens.msg.loginError]: "Login gagal. Sila semak emel dan kata laluan anda",
  [tokens.msg.deleteSuccess]: "Berjaya dipadam",
  [tokens.msg.deleteFailed]: "Gagal dipadam",
  [tokens.msg.checkFormErrors]: "Sila semak dan betulkan ralat borang",
  [tokens.msg.noRecordsFound]: "Tiada rekod dijumpai",
  [tokens.msg.atLeastOneParameterRequired]:
    "Sekurang-kurangnya satu parameter kualiti air diperlukan",
  [tokens.msg.reportCodeAutoGenerated]:
    "No siri laporan akan dijana secara automatik apabila disimpan",
  [tokens.label.systemName]: "Sistem Pemantauan Kualiti Air",
  [tokens.label.email]: "Alamat Emel",
  [tokens.label.password]: "Kata Laluan",
  [tokens.label.forgetPassword]: "Terlupa Kata Laluan?",
  [tokens.label.continue]: "Teruskan",
  [tokens.label.systemShortName]: "WQMS",
  [tokens.label.siteNameHint]: "Petunjuk Nama Tapak",
  [tokens.label.siteName]: "Nama Tapak",
  [tokens.label.filters]: "Saring",
  [tokens.label.dateRange]: "Julat Tarikh",
  [tokens.label.dateFrom]: "Dari",
  [tokens.label.dateTo]: "Hingga",
  [tokens.label.from]: "Dari",
  [tokens.label.to]: "Hingga",
  [tokens.label.all]: "Semua",
  [tokens.label.sourcePoint]: "Titik Sumber",
  [tokens.label.view]: "Lihat",
  [tokens.label.districts]: "Daerah",
  [tokens.label.siteDetails]: "Perincian Tapak",
  [tokens.label.siteCode]: "Kod Tapak",
  [tokens.label.manufacturer]: "Pengilang",
  [tokens.label.modelNo]: "No Model",
  [tokens.label.size]: "Saiz",
  [tokens.label.startDate]: "Tarikh Mula",
  [tokens.label.modemType]: "Jenis Modem",
  [tokens.label.partNo]: "No Bahagian",
  [tokens.label.description]: "Deskripsi",
  [tokens.label.firmwareVersion]: "Versi `Firmware`",
  [tokens.label.hardwareVersion]: "Versi `Hardware`",
  [tokens.label.powerSource]: "Sumber Kuasa",
  [tokens.label.antennaType]: "Jenis Antenna",
  [tokens.label.coordinateX]: "Latitude",
  [tokens.label.coordinateY]: "Longitude",
  [tokens.label.elevation]: "Ketinggian",
  [tokens.label.readings]: "Bacaan",
  [tokens.label.datetime]: "Tarikh & Masa",
  [tokens.label.time]: "Masa",
  [tokens.label.editSite]: "Kemaskini Tapak",
  [tokens.label.viewChart]: "Paparan Graf",
  [tokens.label.noDataFound]: "Tiada data dijumpai",
  [tokens.label.codeRequired]: "Kod perlu diisi",
  [tokens.label.nameRequired]: "Nama perlu diisi",
  [tokens.label.invalidPostcode]: "Poskod tidak sah",
  [tokens.label.siteUpdated]: "Maklumat tapak telah berjaya dikemaskini",
  [tokens.label.errorOccurred]: "Terdapat ralat berlaku",
  [tokens.label.accountNo]: "No Akaun",
  [tokens.label.address1]: "Alamat 1",
  [tokens.label.address2]: "Alamat 2",
  [tokens.label.address3]: "Alamat 3",
  [tokens.label.postcode]: "Poskod",
  [tokens.label.city]: "Bandar",
  [tokens.label.district]: "Daerah",
  [tokens.label.editMeter]: "Kemaskini Meter",
  [tokens.label.serialNo]: "No Siri",
  [tokens.label.meterType]: "Jenis Meter",
  [tokens.label.startRead]: "Bacaan Awal",
  [tokens.label.endDate]: "Tarikh Tamat",
  [tokens.label.endRead]: "Bacaan Akhir",
  [tokens.label.update]: "Kemaskini",
  [tokens.label.selectDistrict]: "Pilih Daerah",
  [tokens.label.selectMeterType]: "Pilih Jenis Meter",
  [tokens.label.siteList]: "Senarai Tapak",
  [tokens.label.siteSearch]: "Carian nama tapak",
  [tokens.label.highestHourly]: "Tertinggi Jam",
  [tokens.label.yesterdayDiff]: "P'bezaan Semlm",
  [tokens.label.highestDaily]: "Tertinggi Harian",
  [tokens.label.monthDiff]: "P'bezaan Bln Sblm",
  [tokens.label.flowCount]: "Kiraan Bacaan",
  [tokens.label.runDate]: "Tarikh Berjalan",
  [tokens.label.runStart]: "Masa Mula",
  [tokens.label.runEnd]: "Masa Selesai",
  [tokens.label.timeTaken]: "Masa Diambil",
  [tokens.label.totalData]: "Jumlah Data",
  [tokens.label.totalProcessed]: "Jumlah Diproses",
  [tokens.label.runStatus]: "Status Proses",
  [tokens.label.showProcessIncompleteOnly]:
    "Hanya paparkan jumlah data \u2260 jumlah diproses",
  [tokens.label.complete]: "Lengkap",
  [tokens.label.incomplete]: "Tidak Lengkap",
  [tokens.label.nodata]: "Tiada Data",
  [tokens.label.viewer]: "Paparan",
  [tokens.label.timeTakenOpt1]: "{0} minit dan {1} saat",
  [tokens.label.timeTakenOpt2]: "{0} minit dan {1} saat",
  [tokens.label.timeTakenOpt3]: "{0} saat",
  [tokens.label.jobSummaryDesc]: "Jadual kerja dan hasil proses",
  [tokens.label.operationDesc]:
    "Operasi proses dijadualkan pada setiap 12AM dan 12PM",
  [tokens.label.date]: "Tarikh",
  [tokens.label.result]: "Hasil",
  [tokens.label.flowCountIncomplete]: "Kiraan Bacaan Tidak Lengkap",
  [tokens.label.sharpIncreaseFlowSma]: "Peningkatan Mendadak dalam flow SMA",
  [tokens.label.onlineSite]: "Tapak-tapak Logger Online",
  [tokens.label.offlineSite]: "Tapak-tapak Logger Offline",
  [tokens.label.topConsumer]: "Pengguna Tertinggi",
  [tokens.label.topConsumerDesc]:
    "10 pelanggan dengan penggunaan air tertinggi bulan ini",
  [tokens.label.lastJobRun]: "Kerja berjalan terakhir pada",
  [tokens.label.nextJobRun]: "Kerja akan berjalan berikutnya pada",
  [tokens.label.days]: "hari",
  [tokens.label.hours]: "jam",
  [tokens.label.minutes]: "minit dahulu",
  [tokens.label.editSftp]: "SFTP",
  [tokens.label.editMnHours]: "`Min Night Hours`",
  [tokens.label.configUpdated]: "Tetapan telah berjaya dikemaskini",
  [tokens.label.sftpHost]: "Host",
  [tokens.label.sftpPort]: "Port",
  [tokens.label.sftpUser]: "Nama Pengguna",
  [tokens.label.sftpPw]: "Kata Laluan",
  [tokens.label.sftpRemoteDir]: "Remote Dir",
  [tokens.label.mnStart]: "Jam Mula",
  [tokens.label.mnEnd]: "Jam Akhir",
  [tokens.label.sftpHostRequired]: "SFTP Host perlu diisi",
  [tokens.label.sftpPortRequired]: "SFTP Port perlu diisi",
  [tokens.label.sftpUserRequired]: "Pengguna perlu diisi",
  [tokens.label.sftpRemoteDirRequired]: "Remote Dir perlu diisi",
  [tokens.label.active]: "Aktif",
  [tokens.label.inactive]: "Tidak Aktif",
  [tokens.label.address]: "Alamat",
  [tokens.label.logType]: "Jenis Log",
  [tokens.label.logDate]: "Tarikh Log",
  [tokens.label.noLog]: "Tiada log dijumpai",
  [tokens.label.allDistricts]: "Semua Daerah",
  [tokens.label.editLoggerType]: "Kemaskini Jenis Logger",
  [tokens.label.loggerTypeUpdated]: "Jenis Logger telah berjaya dikemaskini",
  [tokens.label.descRequired]: "Deskripsi perlu diisi",
  [tokens.label.manufacturerRequired]: "Pengilang perlu diisi",
  [tokens.label.parNoRequired]: "No Bahagian perlu diisi",
  [tokens.label.back]: "Kembali",
  [tokens.label.loggerDetails]: "Perincian Jenis Logger",
  [tokens.label.createLoggerType]: "Tambah Jenis Logger",
  [tokens.label.createSite]: "Tambah Tapak",
  [tokens.label.selectLoggerType]: "Pilih Jenis Logger",
  [tokens.label.loggerSerialNo]: "No Siri Logger",
  [tokens.label.loggerTypeRequired]: "Jenis Logger perlu dipilih",
  [tokens.label.loggerSnRequired]: "No Siri Logger perlu diisi",
  [tokens.label.position]: "Posisi",
  [tokens.label.districtRequired]: "Daerah perlu dipilih",
  [tokens.label.largeLogFile]:
    "Fail dimuat turun kerana saiz log melebihi 5MB.",
  [tokens.label.clientName]: "Lembaga Sumber Air Negeri Kedah",
  [tokens.label.clientNameShort]: "LSANK",
  [tokens.label.roleName]: "Nama Peranan",
  [tokens.label.roleAccess]: "Akses Peranan",
  [tokens.label.actions]: "Tindakan",
  [tokens.label.editRole]: "Kemas Kini Peranan",
  [tokens.label.language]: "Tetapan Bahasa",
  [tokens.label.theme]: "Tetapan Tema",
  [tokens.label.moduleName]: "Nama Modul",
  [tokens.label.access]: "Akses",
  [tokens.label.roleFilterKey]: "Masukkan nama peranan di sini",
  [tokens.label.addRole]: "Tambah Peranan",
  [tokens.label.moduleAccess]: "Akses Modul",
  [tokens.label.save]: "Simpan",
  [tokens.label.scrollMore]: "Skrol untuk melihat lebih banyak pilihan",
  [tokens.label.maxLength]: "Maksimum karekter adalah ",
  [tokens.label.minLength]: "Minimum karekter adalah ",
  [tokens.label.fieldRequired]: "Medan ini perlu diisi",
  [tokens.label.roleUpdated]: "Maklumat peranan berjaya disimpan",
  [tokens.label.pressEnter]: "Tekan 'Enter' selepas memasukkan kata kunci",
  [tokens.label.name]: "Nama",
  [tokens.label.username]: "Nama Pengguna",
  [tokens.label.fullName]: "Nama Penuh",
  [tokens.label.phone]: "No Telefon",
  [tokens.label.role]: "Peranan",
  [tokens.label.lastLogin]: "Log Masuk Terakhir",
  [tokens.label.createdDate]: "Tarikh Ditambah",
  [tokens.label.createdBy]: "Ditambah Oleh",
  [tokens.label.modifiedDate]: "Tarikh Dikemas Kini",
  [tokens.label.modifiedBy]: "Dikemas Kini Oleh",
  [tokens.label.userFilterKey]: "Masukkan nama penuh atau pengguna di sini",
  [tokens.label.viewUser]: "Maklumat Pengguna",
  [tokens.label.editUser]: "Kemas Kini Pengguna",
  [tokens.label.changePassword]: "Tukar Kata Laluan",
  [tokens.label.addUser]: "Tambah Pengguna",
  [tokens.label.selectRole]: "Pilih Peranan",
  [tokens.label.passwordMin]: "Mestilah sekurang-kurangnya 8 aksara.",
  [tokens.label.passwordMatches]:
    "Min 8 aksara, 1 huruf besar, 1 huruf kecil, 1 digit angka.",
  [tokens.label.confirmPasswordMatches]: "Kata laluan mesti sepadan",
  [tokens.label.confirmPassword]: "Kata Laluan (Pengesahan)",
  [tokens.label.invalidPhone]: "Telefon memerlukan 9 - 11 aksara",
  [tokens.label.invalidPhoneExtra]: "Telefon terdiri dari nombor sahaja",
  [tokens.label.validEmail]: "Perlu alamat emel yang sah",
  [tokens.label.userUpdated]: "Maklumat pengguna berjaya disimpan",
  [tokens.label.selectOptionRequired]: "Sila pilih satu pilihan",
  [tokens.label.action]: "Tindakan",
  [tokens.label.allActions]: "Semua Tindakan",
  [tokens.label.entityName]: "Entiti",
  [tokens.label.allEntityNames]: "Semua Entiti",
  [tokens.label.ipAddress]: "Alamat IP",
  [tokens.label.userAgent]: "Ejen Pengguna",
  [tokens.label.note]: "Maaf, tiada maklumat tambahan",
  [tokens.label.beforeState]: "Data Sebelum",
  [tokens.label.afterState]: "Data Selepas",
  [tokens.label.reason]: "Sebab",
  [tokens.label.activate]: "Aktifkan",
  [tokens.label.deactivate]: "Nyahaktifkan",
  [tokens.label.userStatusUpdated]: "Status pengguna berjaya ditukar",
  [tokens.label.passwordChangeSuccess]:
    "Kata Laluan berjaya ditukar. Anda akan dilog keluar selepas {{time}} saat.",
  [tokens.label.logoutNow]: "Log Keluar Sekarang",
  [tokens.label.export]: "Eksport",
  [tokens.label.newPassword]: "Kata Laluan Baru",
  [tokens.label.stationFilterKey]: "Masukkan kod atau nama station",
  [tokens.label.rtuFilterKey]: "Masukkan no siri atau no model RTU",
  [tokens.label.valueInNumber]: "Nilai mestilah dalam nombor perpuluhan",
  [tokens.label.addStation]: "Tambah Stesen",
  [tokens.label.updateStation]: "Kemas Kini Stesen",
  [tokens.label.viewStation]: "Maklumat Stesen",
  [tokens.label.stationUpdated]: "Maklumat stesen berjaya disimpan",
  [tokens.label.stationName]: "Nama Stesen",
  [tokens.label.stationCode]: "Kod Stesen",
  [tokens.label.location]: "Lokasi",
  [tokens.label.rtu]: "RTU",
  [tokens.label.selectRtu]: "Pilih RTU",
  [tokens.label.coordX]: "Latitud",
  [tokens.label.coordY]: "Longitud",
  [tokens.label.distanceToStation]: "Jarak ke Stesen (km)",
  [tokens.label.getLocation]: "Dapatkan Lokasi Sekarang",
  [tokens.label.rtuUpdated]: "Maklumat RTU berjaya disimpan",
  [tokens.label.addRTU]: "Tambah RTU",
  [tokens.label.editRTU]: "Kemas Kini RTU",
  [tokens.label.viewRTU]: "Maklumat RTU",
  [tokens.label.accessKey]: "Kunci Akses",
  [tokens.label.getAccessKey]: "Dapatkan Kunci Akses",
  [tokens.label.viewAccessKey]: "Lihat Kunci Akses",
  [tokens.label.brand]: "Jenama",
  [tokens.label.rtuStatusUpdated]: "Status RTU berjaya ditukar",
  [tokens.label.rtuKeyUpdated]: "Kunci akses RTU berjaya dikemas kini",
  [tokens.label.rtuKeyDesc]:
    "Kunci akses diperlukan untuk RTU mengakses dan menghantar data ke API WQMS. Adakah anda ingin menjana kunci akses baharu untuk RTU ini?",
  [tokens.label.close]: "Tutup",
  [tokens.label.copyToClipboard]: "Salin ke Papan Klip",
  [tokens.label.copied]: "Telah Disalin!",
  [tokens.label.coordinate]: "Koordinat",
  [tokens.label.stationStatusUpdated]: "Status stesen berjaya ditukar",
  [tokens.label.zoomIn]: "Zum Masuk",
  [tokens.label.viewDetails]: "Paparan Perincian Stesen",
  [tokens.label.viewOutlets]: "Paparan Titik Punca",
  [tokens.label.addOutlet]: "Tambah Titik Punca",
  [tokens.label.editOutlet]: "Kemas Kini Titik Punca",
  [tokens.label.viewOutlet]: "Maklumat Titik Punca",
  [tokens.label.outletName]: "Nama Titik Punca",
  [tokens.label.regNo]: "No Daftar",
  [tokens.label.outletUpdated]: "Maklumat titik punca berjaya disimpan",
  [tokens.label.outletStatusUpdated]: "Status titik punca berjaya ditukar",
  [tokens.label.loading]: "Sedang diproses...",
  [tokens.label.threshold]: "Had Parameter",
  [tokens.label.alert]: "Amaran",
  [tokens.label.paramName]: "Nama Parameter",
  [tokens.label.paramShortName]: "Nama Pendek Parameter",
  [tokens.label.paramUnit]: "Unit Parameter",
  [tokens.label.setLimit]: "Set Had",
  [tokens.label.warningLimit]: "Had Amaran",
  [tokens.label.criticalLimit]: "Had Kritikal",
  [tokens.label.thresholdUpdated]: "Maklumat had parameter berjaya disimpan",
  [tokens.label.largerThanCritical]:
    "Nilai perlu sama atau lebih besar dari had kritikal",
  [tokens.label.largerThanWarning]:
    "Nilai perlu sama atau lebih besar dari had amaran",
  [tokens.label.lessThanCritical]:
    "Nilai perlu sama atau lebih besar dari had kritikal",
  [tokens.label.lessThanWarning]:
    "Nilai perlu sama atau lebih besar dari had amaran",
  [tokens.label.higherIsBetter]:
    "Had amaran mesti sama atau lebih besar dari had kritikal",
  [tokens.label.hasTwoSides]:
    "Mempunyai dua bahagian had, had atas dan had bawah",
  [tokens.label.lowerIsBetter]:
    "Had amaran mesti sama atau lebih kecil dari had kritikal",
  [tokens.label.alertEmailUpdated]:
    "Berjaya menambah/mengemas kini e-mel makluman",
  [tokens.label.updateEmail]: "Kemas Kini Alamat E-mel",
  [tokens.label.removeEmail]: "Hapus Alamat E-mel",
  [tokens.label.removeEmailConfirm]:
    "Adakah anda pasti untuk menghapuskan alamat e-mel ini?",
  [tokens.label.continue]: "Teruskan",
  [tokens.label.alertEmailRemoved]: "E-mel makluman berjaya dihapuskan",
  [tokens.label.outlet]: "Titik Punca",
  [tokens.label.selectMukim]: "Pilih Mukim",
  [tokens.label.mukim]: "Mukim",
  [tokens.label.note1]: "Nota",
  [tokens.label.stationOverview]: "Stesen (Keseluruhan)",
  [tokens.label.stationOverviewDesc]:
    "Gambar stesen secara menyeluruh termasuk persekitaran",
  [tokens.label.stationCloseUp]: "Stesen (Dekat)",
  [tokens.label.stationCloseUpDesc]: "Gambar dekat stesen",
  [tokens.label.stationOptional]: "Stesen (Pilihan)",
  [tokens.label.stationOptionalDesc]: "Gambar stesen untuk rujukan tambahan",
  [tokens.label.noPicture]: "Tiada gambar tersedia. Sila muat naik",
  [tokens.label.ssmNo]: "No Pendaftaran Syarikat (SSM)",
  [tokens.label.outletOverview]: "Titik Sumber (Keseluruhan)",
  [tokens.label.outletOverviewDesc]:
    "Gambar premis/lokasi titik sumber secara menyeluruh termasuk persekitaran",
  [tokens.label.outletCloseUp]: "Titik Sumber (Dekat)",
  [tokens.label.outletCloseUpDesc]:
    "Gambar dekat tempat keluar titik sumber ke sungai",
  [tokens.label.outletOptional]: "Titik Sumber (Pilihan)",
  [tokens.label.outletOptionalDesc]:
    "Gambar titik sumber untuk tujukan tambahan",
  [tokens.label.delete]: "Hapus",
  [tokens.label.deleteOutlet]: "Hapus Titik Sumber",
  [tokens.label.deleteOutletConfirm]:
    "Adakah anda pasti untuk menghapuskan titik sumber ini? Tindakan ini tidak boleh dibatalkan.",
  [tokens.label.outletRemoved]: "Berjaya menghapuskan titik sumber ini",
  [tokens.label.detailInfo]: "Perincian",
  [tokens.label.samplingData]: "Data Persampelan",
  [tokens.label.samplingDate]: "Tarikh Persampelan",
  [tokens.label.readingDate]: "Tarikh Bacaan",
  [tokens.label.parameters]: "Parameter",
  [tokens.label.missingData]: "Tiada Data",
  [tokens.label.stationInfo]: "Maklumat Stesen",
  [tokens.label.reading]: "Bacaan",
  [tokens.label.exportToExcel]: "Eksport ke Excel",
  [tokens.label.station]: "Stesen",
  [tokens.label.displayReading]: "Papar Bacaan",
  [tokens.label.readingData]: "Data Bacaan",
  [tokens.label.noDataToDisplay]: "Tiada data untuk dipaparkan",
  [tokens.label.seeStation]: "Lihat stesen",
  [tokens.label.seeAlarm]: "Lihat penggera",
  [tokens.label.cleanRiver]: "Sungai Bersih",
  [tokens.label.slightlyPollutedRiver]: "Sungai Sedikit Tercemar",
  [tokens.label.pollutedRiver]: "Sungai Tercemar",
  [tokens.label.alarmTriggered]: "Penggera Tercetus",
  [tokens.label.wqi]: "Indeks Kualiti Air",
  [tokens.label.wqiDesc]: "Bacaan WQI dan parameter di setiap stesen",
  [tokens.label.inSituWqi]: "WQI In-Situ",
  [tokens.label.inSituWqiDesc]:
    "Bacaan WQI di setiap lokasi persampelan in-situ",
  [tokens.label.openStationOverview]: "Papar Butiran Stesen",
  [tokens.label.hydro]: "Hidrologi",
  [tokens.label.hydroDesc]: "Bacaan hidrologi di setiap stesen",
  [tokens.label.compareTime]: "Set Perbandingan Masa",
  [tokens.label.autoLoadStop]: "Muat semula automatik dihentikan",
  [tokens.label.autoLoadResume]: "Muat semula automatik diteruskan semula",
  [tokens.label.stopRefresh]: "Berhenti Muat Semula Automatik",
  [tokens.label.refreshResume]: "Sambung Muat Semula Automatik",
  [tokens.label.last5alarms]: "5 Alarm Terkini",
  [tokens.label.wqiStationDesc]: "Bacaan WQI dan parameter",
  [tokens.label.hydroStationDesc]: "Bacaan hidrologi",
  [tokens.label.map]: "Peta",
  [tokens.label.enterZenMode]: "Masuk Mod Zen",
  [tokens.label.exitZenMode]: "Keluar Mod Zen",
  [tokens.label.confirmLogout]: "Adakah anda pasti mahu log keluar?",
  [tokens.label.cancel]: "Batal",
  [tokens.label.seeDashboard]: "Lihat Papan Pemuka Awam",
  [tokens.label.date]: "Tarikh",
  [tokens.label.generate]: "Jana",
  [tokens.label.dailyReport]: "Laporan Bacaan Harian",
  [tokens.label.monthlyReport]: "Laporan Bacaan Bulanan",
  [tokens.label.stationSourcePointList]: "Senarai Stesen & Titik Sumber",
  [tokens.label.alarmReport]: "Laporan Penggera",
  [tokens.label.month]: "Bulan",
  [tokens.label.selectStationAndParameter]: "Pilih stesen dan parameter",
  [tokens.label.selectAll]: "Pilih Semua",
  [tokens.label.deselectAll]: "Batal Pilih Semua",
  [tokens.label.dailyAlarmReport]: "Laporan Penggera Harian",
  [tokens.label.monthlyAlarmReport]: "Laporan Penggera Bulanan",
  [tokens.label.monthlyReportSummary]: "Ringkasan Laporan Bacaan Bulanan",
  [tokens.label.dailyReportSummary]: "Ringkasan Laporan Bacaan Harian",
  [tokens.label.expectedData]: "Data Dijangka",
  [tokens.label.actualData]: "Data Diterima",
  [tokens.label.missingData]: "Data Hilang",
  [tokens.label.percentageMissingData]: "Peratusan Data Hilang",
  [tokens.label.parameterDetails]: "Butiran Parameter",
  [tokens.label.yes]: "Ya",
  [tokens.label.no]: "Tidak",
  [tokens.label.totalExpectedData]: "Jumlah Data Dijangka",
  [tokens.label.totalActualData]: "Jumlah Data Diterima",
  [tokens.label.totalMissingData]: "Jumlah Data Hilang",
  [tokens.label.monthlyReportFileTitle]: "Laporan_Bulanan-",
  [tokens.label.dailyReportFileTitle]: "Laporan_Bacaan_Harian-",
  [tokens.label.alarmDesc]: "Butiran Penggera",
  [tokens.label.monthlyAlarmReportFileTitle]: "Laporan_Penggera_Bulanan-",
  [tokens.label.dailyAlarmReportFileTitle]: "Laporan_Penggera_Harian-",
  [tokens.label.dailyReadings]: "Bacaan Harian",
  [tokens.label.stationSourceReport]: "Senarai Stesen dan Titik Sumber",
  [tokens.label.stationDetails]: "Butiran Stesen",
  [tokens.label.rtuSerialNo]: "No Serial RTU",
  [tokens.label.rtuModelNo]: "No Model RTU",
  [tokens.label.rtuBrand]: "Jenama RTU",
  [tokens.label.stationSourceReportFileTitle]: "Stesen_dan_Titik_Punca",
  [tokens.label.sample]: "Sampel",
  [tokens.label.keyWord]: "Kata Kunci",
  [tokens.label.auditReportTitle]: "Log_Audit-",
  [tokens.label.alarmReportTitle]: "Senarai_Penggera-",
  [tokens.label.alarmCount]: "Kiraan Penggera",
  [tokens.label.alarmCountByDate]: "Kiraan Penggera Mengikut Tarikh",
  [tokens.label.alarmFrequency]: "Kekerapan Penggera",
  [tokens.label.noAlarm]: "Tiada Penggera",
  [tokens.label.low]: "Rendah",
  [tokens.label.medium]: "Sederhana",
  [tokens.label.high]: "Tinggi",
  [tokens.label.veryHigh]: "Sangat Tinggi",
  [tokens.label.alertEmailInstruction]:
    "Sila masukkan e-mel pengguna yang akan menerima notifikasi amaran.",
  [tokens.label.installedAt]: "Dipasang di",
  [tokens.label.sourcePointList]: "Senarai Titik Punca",
  [tokens.label.stationOutletName]: "Stesen/Titik Punca",
  [tokens.label.sourcePointListSubtitle]:
    "Senarai titik punca dan data sampling",
  [tokens.label.lastRefreshAt]: "Muat semula terakhir pada",
  [tokens.label.emailToReceiveNotification]:
    "Senarai e-mel yang akan menerima notifikasi amaran",
  [tokens.label.emailNotification]: "Notifikasi E-mel",
  [tokens.label.currentWQI]: "WQI Semasa",
  [tokens.label.upperLimit]: "Had Atas",
  [tokens.label.lowerLimit]: "Had Bawah",
  [tokens.label.largerThanUpperCritical]: "Lebih besar daripada nilai had atas",
  [tokens.label.lessThanLowerCritical]: "Kurang daripada nilai had bawah",
  [tokens.label.lowerWarningLimit]: "Had Bawah Amaran",
  [tokens.label.lowerCriticalLimit]: "Had Bawah Kritikal",
  [tokens.label.upperWarningLimit]: "Had Atas Amaran",
  [tokens.label.upperCriticalLimit]: "Had Atas Kritikal",
  [tokens.label.kkmLimits]: "Had Piawaian KKM",
  [tokens.label.jasLimits]: "Had Piawaian JAS",
  [tokens.label.sendCommandGrabSample]: "Hantar arahan untuk ambil sampel",
  [tokens.label.sendCommandGrabSampleConfirm]:
    "Adakah anda pasti untuk menghantar arahan untuk ambil sampel?",
  [tokens.label.commandSent]:
    "Arahan telah disimpan dan sedang menunggu untuk dihantar ke RTU.",
  [tokens.label.commandFailed]: "Arahan gagal dihantar",
  [tokens.label.seeCommandHistory]: "Lihat Sejarah Arahan",
  [tokens.label.commandHistory]: "Sejarah Arahan",
  [tokens.label.mode]: "Mod",
  [tokens.label.publicView]: "Paparan Awam",
  [tokens.label.publicViewDesc]: "Bacaan kualiti air untuk paparan awam",
  [tokens.label.approvedBy]: "Diluluskan Oleh",
  [tokens.label.approvedDate]: "Tarikh Lulus",
  [tokens.label.currentPublicView]: "Paparan WQI Awam Semasa",
  [tokens.label.toBeApprovedPublicView]:
    "Paparan WQI Awam Untuk Diluluskan. Sila semak dan luluskan.",
  [tokens.label.approve]: "Luluskan",
  [tokens.label.wqiApproveSuccess]: "Pelulusan WQI berjaya diterima",
  [tokens.label.wqiApproveFailed]: "Pelulusan WQI gagal diterima",
  [tokens.label.approved]: "Telah Diluluskan",
  [tokens.label.wqiCancelSuccess]: "Pembatalan WQI berjaya diterima",
  [tokens.label.wqiCancelFailed]: "Pembatalan WQI gagal diterima",
  [tokens.label.noWQIApproved]: "Tiada kelulusan",
  [tokens.label.dataMaintenance]: "Penyelenggaraan Data",
  [tokens.label.dataMaintenanceDesc]:
    "Penyelenggaraan data untuk bacaan harian",
  [tokens.label.rtuDataFile]: "Fail Data RTU (WQI)",
  [tokens.label.rtuDataFileDesc]: "Fail WQI data RTU untuk bacaan harian",
  [tokens.label.uploadRTUFile]: "Muat Naik Fail RTU [WQI]",
  [tokens.label.uploadRTUFileDesc]:
    "Muat naik fail data RTU untuk bacaan harian. Fail mesti dalam format CSV. Saiz maksimum fail adalah 20MB.",
  [tokens.label.fileExceedSize]:
    "Fail melebihi saiz maksimum. Sila muat naik fail yang lebih kecil.",
  [tokens.label.doNotCloseWindowWhileProcessing]:
    "Sila jangan tutup tetingkap ini semasa proses sedang berjalan.",
  [tokens.label.startProcess]: "Mula Proses",
  [tokens.label.processCompleted]: "Proses telah selesai",
  [tokens.label.processFailed]: "Proses gagal",
  [tokens.label.processInProgress]: "Proses sedang berjalan",
  [tokens.label.addLocation]: "Tambah Lokasi",
  [tokens.label.updateLocation]: "Kemas Kini Lokasi",
  [tokens.label.location]: "Lokasi",
  [tokens.label.locationInfo]: "Maklumat Lokasi",
  [tokens.label.locationName]: "Nama Lokasi",
  [tokens.label.locationCode]: "Kod Lokasi",
  [tokens.label.locationView]: "Paparan Lokasi",
  [tokens.label.uploadLocationView]: "Muat Naik Paparan Lokasi",
  [tokens.label.samplePoint]: "Paparan Titik Sampel",
  [tokens.label.uploadSamplePoint]: "Muat Naik Paparan Titik Sampel",
  [tokens.label.surrounding]: "Paparan Persekitaran",
  [tokens.label.uploadSurrounding]: "Muat Naik Paparan Persekitaran",
  [tokens.label.latestSamplingWQI]: "WQI Persampelan Terkini",
  [tokens.label.latestSamplingDate]: "Tarikh Persampelan Terkini",
  [tokens.label.latestSamplingUpdatedBy]:
    "Pensampelan Terkini Dikemas Kini Oleh",
  [tokens.label.sampleDate]: "Tarikh Sampel",
  [tokens.label.createdDate]: "Tarikh Dicipta",
  [tokens.label.sampledBy]: "Disampel Oleh",
  [tokens.label.analyzedBy]: "Dianalisis Oleh",
  [tokens.label.labReference]: "Rujukan Makmal",
  [tokens.label.remarks]: "Catatan",
  [tokens.label.temperature]: "Suhu",
  [tokens.label.latestReading]: "Bacaan Terkini",
  [tokens.label.latestReadingDetails]: "Butiran Bacaan Terkini",
  [tokens.label.wqiValue]: "Nilai WQI (Pengiraan Automatik)",
  [tokens.label.wqiValueHelper]:
    "WQI dikira secara automatik berdasarkan parameter lain",
  [tokens.label.readingsTabInfo]:
    "Gunakan tab ini untuk merekodkan bacaan pensampelan kualiti air terkini untuk lokasi ini. Isikan parameter yang diukur dan WQI akan dikira secara automatik.",
  [tokens.label.samplingHistory]: "Sejarah Pensampelan",
  [tokens.label.editReading]: "Kemaskini Bacaan",
  [tokens.label.addReading]: "Tambah Bacaan",
  [tokens.label.addNewReading]: "Tambah Bacaan Baharu",
  [tokens.label.editReadingInfo]:
    "Rekod boleh dikemaskini dalam tempoh 7 hari dari tarikh dicipta.",
  [tokens.label.readingUpdated]: "Bacaan berjaya dikemaskini",
  [tokens.label.readingCreated]: "Bacaan berjaya dicipta",
  [tokens.label.exportDate]: "Tarikh Eksport",
  [tokens.label.totalRecords]: "Jumlah Rekod",
  [tokens.label.exportSuccess]: "Eksport berjaya",
  [tokens.label.exportFailed]: "Eksport gagal",
  [tokens.label.errorLoadingData]: "Ralat memuatkan data",
  [tokens.label.searchKeyword]: "Kata Kunci Carian",
  [tokens.label.dateRangeSampling]: "Julat Tarikh Pensampelan",
  [tokens.label.resetFilters]: "Set Semula Penapis",

  // Inspection Report
  [tokens.label.inspectionReport]: "Laporan Pemeriksaan",
  [tokens.label.inspectionReports]: "Laporan Pemeriksaan",
  [tokens.label.createInspectionReport]: "Tambah Laporan Pemeriksaan",
  [tokens.label.editInspectionReport]: "Kemaskini Laporan Pemeriksaan",
  [tokens.label.reportTitle]: "Tajuk Laporan",
  [tokens.label.reportDate]: "Tarikh Laporan",
  [tokens.label.reportStatus]: "Status Laporan",
  [tokens.label.reportNumber]: "Nombor Laporan",
  [tokens.label.reportCode]: "No Siri Laporan",
  [tokens.label.fileNo]: "No. Fail",
  [tokens.label.pollutionComplaint]:
    "Laporan Pemeriksaan Aduan Pencemaran Sumber Air",
  [tokens.label.licensingInspection]:
    "Laporan Pemeriksaan Permohonan Pelesenan / Pemantauan Tapak Perlesenan\n(Peraturan-peraturan Aktiviti Pelepasan Efluen 2017)",
  [tokens.label.pdfPreview]: "Pratonton PDF",
  [tokens.label.inspectionReportPreview]: "Pratonton Laporan Pemeriksaan",

  // Location Section
  [tokens.label.locationInfo]: "Maklumat Lokasi",
  [tokens.label.district]: "Daerah",
  [tokens.label.mukim]: "Mukim",
  [tokens.label.addressLine1]: "Alamat Baris 1",
  [tokens.label.addressLine2]: "Alamat Baris 2",
  [tokens.label.addressLine3]: "Alamat Baris 3",
  [tokens.label.gpsCoordinates]: "Koordinat GPS",
  [tokens.label.latitude]: "Latitud",
  [tokens.label.longitude]: "Longitud",

  // Officers Section
  [tokens.label.officersInfo]: "Maklumat Pegawai",
  [tokens.label.inspectionOfficers]: "Pegawai Pemeriksa",
  [tokens.label.selectInspectionOfficers]: "Pilih pegawai pemeriksa",
  [tokens.label.additionalOfficers]:
    "Pegawai Tambahan (Tiada Dalam Senarai Pengguna WQMS)",
  [tokens.label.additionalOfficersPlaceholder]:
    "Cth:\nNama Pegawai 1\nNama Pegawai 2\nNama Pegawai 3\n...",
  [tokens.label.additionalOfficersHelper]:
    "Masukkan nama pegawai yang tiada dalam senarai pengguna WQMS, satu nama setiap baris",
  [tokens.label.selectOfficers]: "Pilih Pegawai",
  [tokens.label.siteOfficer]: "Pegawai Tapak",
  [tokens.label.siteOfficerName]: "Nama Pegawai / Penyelia / PIC di tapak",
  [tokens.label.siteOfficerNamePlaceholder]: "Nama pegawai di tapak",
  [tokens.label.siteOfficerPosition]:
    "Jawatan Pegawai / Penyelia / PIC di tapak",
  [tokens.label.siteOfficerPhone]: "No Telefon Pegawai/Penyelia/PIC di tapak",
  [tokens.label.siteOfficerEmail]: "Emel Pegawai/Penyelia/PIC di tapak",
  [tokens.label.activityType]: "Jenis Aktiviti",

  // Schedule & Timing
  [tokens.label.scheduleInfo]: "Tarikh dan Masa Pemeriksaan",
  [tokens.label.inspectionDate]: "Tarikh Pemeriksaan",
  [tokens.label.inspectionTime]: "Masa Pemeriksaan",

  // Findings Section
  [tokens.label.findingsObservations]: "Penemuan & Pemerhatian",
  [tokens.label.checkboxInstruction]:
    "Tandakan ☑ jika dipatuhi. Nyatakan butiran lanjut jika tidak dipatuhi.",
  [tokens.label.enforcementInstruction]:
    "Tandakan ☑ jika notis dikeluarkan dan isi no siri serta butiran notis (pilihan).",
  [tokens.label.wasteDischarge]: "Pelepasan Sisa",
  [tokens.label.dischargeSurfaceWater]: "Pelepasan ke Air Permukaan",
  [tokens.label.dischargePublicSewer]: "Pelepasan ke Pembetung Awam",
  [tokens.label.dischargeStormDrain]: "Pelepasan ke Longkang Ribut",
  [tokens.label.dischargeOther]: "Kaedah Pelepasan Lain",
  [tokens.label.specifyOther]: "Sila Nyatakan",
  [tokens.label.treatmentFacilities]: "Kemudahan Rawatan",
  [tokens.label.preliminaryTreatment]: "Rawatan Awal",
  [tokens.label.primaryTreatment]: "Rawatan Primer",
  [tokens.label.secondaryTreatment]: "Rawatan Sekunder",
  [tokens.label.tertiaryTreatment]: "Rawatan Tertiari",
  [tokens.label.noTreatment]: "Tiada Rawatan",
  [tokens.label.environmentalIssues]: "Isu Alam Sekitar Diperhatikan",
  [tokens.label.odorComplaint]: "Aduan Bau",
  [tokens.label.colorDischarge]: "Pelepasan Berwarna",
  [tokens.label.foamFormation]: "Pembentukan Buih",
  [tokens.label.solidWaste]: "Sisa Pepejal",
  [tokens.label.oilGrease]: "Minyak & Gris",
  [tokens.label.chemicalContainers]: "Bekas Kimia",
  [tokens.label.siteConditions]: "Keadaan Tapak",
  [tokens.label.adequateDrainage]: "Sistem Saliran Mencukupi",
  [tokens.label.properBunding]: "Pembendungan Sesuai",
  [tokens.label.coveringStructure]: "Struktur Penutup",
  [tokens.label.securityFencing]: "Pagar Keselamatan",
  [tokens.label.warningSignage]: "Papan Tanda Amaran",
  [tokens.label.compliance]: "Status Pematuhan",
  [tokens.label.validLicense]: "Lesen Alam Sekitar Sah",
  [tokens.label.planApproved]: "Pelan Rawatan Diluluskan",
  [tokens.label.recordsMaintained]: "Rekod Diselenggara dengan Betul",
  [tokens.label.previousNonCompliance]: "Ketidakpatuhan Terdahulu",

  // New Findings Sections
  [tokens.label.licensingDocuments]:
    "Kelengkapan Pelesenan / Dokumen / Dokumen Jabatan Lain",
  [tokens.label.treatmentSystem]: "Sistem Rawatan Efluen",
  [tokens.label.dischargePoint]: "Titik Pelepasan Efluen",
  [tokens.label.parameterCompliance]: "Pematuhan Parameter",
  [tokens.label.safetyAndCleanliness]: "Keselamatan dan Kebersihan",
  [tokens.label.enforcement]: "Penguatkuasaan",

  // a) Licensing/Documents items
  [tokens.label.licenseCopyDisplayed]:
    "1. Salinan Lesen Aktiviti Pelepasan Efluen dipamerkan di premis",
  [tokens.label.licenseStillValid]: "2. Lesen masih sah (tidak tamat tempoh)",
  [tokens.label.effluentPlanAvailable]:
    "3. Pelan aliran efluen / sistem rawatan disimpan di premis",
  [tokens.label.maintenanceRecordsAvailable]:
    "4. Rekod penyelenggaraan sistem rawatan efluen",
  [tokens.label.monitoringRecordsAvailable]:
    "5. Rekod bacaan parameter / pemantauan (jika ada sistem automatik @ laporan manual)",
  [tokens.label.labReportAvailable]:
    "6. Laporan analisis makmal terkini (< 6 bulan)",

  // b) Treatment System items
  [tokens.label.treatmentSystemOperational]:
    "1. Sistem rawatan beroperasi dan berfungsi dengan baik",
  [tokens.label.noDamageToComponents]:
    "2. Tiada kerosakan pada tangki, paip, pam atau komponen utama",
  [tokens.label.clearSeparationEffluentRainwater]:
    "3. Terdapat pengasingan jelas antara efluen dan air hujan",
  [tokens.label.noBypassWithoutTreatment]:
    "4. Tiada aliran terus (bypass) tanpa rawatan",
  [tokens.label.chemicalsStoredProperly]:
    "5. Bahan kimia rawatan disimpan dengan betul",
  [tokens.label.treatmentAreaClean]: "6. Kawasan rawatan bersih dan teratur",

  // c) Discharge Point items
  [tokens.label.dischargePointLabeled]:
    "1. Titik pelepasan efluen dikenal pasti dan dilabel dengan jelas",
  [tokens.label.effluentFlowsApprovedChannel]:
    "2. Efluen mengalir hanya melalui saluran yang diluluskan",
  [tokens.label.noUncontrolledDischarge]:
    "3. Tiada pelepasan tidak terkawal / bocoran",
  [tokens.label.nearbyWaterNotPolluted]:
    "4. Parit, longkang atau sungai berhampiran tidak tercemar",
  [tokens.label.samplingPointAccessible]:
    "5. Sampel boleh diambil di titik pelepasan (sampling point jelas dan selamat)",

  // d) Parameter Compliance items
  [tokens.label.analysisShowsCompliance]:
    "1. Keputusan analisis menunjukkan pematuhan kepada syarat lesen",
  [tokens.label.correctiveActionTaken]:
    "2. Tindakan pembetulan diambil sekiranya terdapat ketidakpatuhan",
  [tokens.label.noUnauthorizedDischarge]:
    "3. Tiada pelepasan tidak dibenarkan ke persekitaran",

  // e) Safety and Cleanliness items
  [tokens.label.safeAccessToTreatment]:
    "1. Laluan ke sistem rawatan selamat dan mudah diakses",
  [tokens.label.workersPPE]:
    "2. Pekerja memakai PPE semasa mengendalikan efluen",
  [tokens.label.noOpenChemicalDisposal]:
    "3. Tiada pembuangan sisa kimia secara terbuka",
  [tokens.label.warningSignsPresent]:
    "4. Kawasan mempunyai papan tanda amaran dan keselamatan",

  // f) Enforcement items
  [tokens.label.noticeSection70]: "1. Notis Pemberitahuan Kesalahan Seksyen 70",
  [tokens.label.noticeSection30]:
    "2. Notis Pemberitahuan Kesalahan Seksyen 30(1)",
  [tokens.label.noticeSection77]: "3. Notis Pemberitahuan Kesalahan Seksyen 77",
  [tokens.label.noticeSection78]: "4. Notis Pemberitahuan Kesalahan Seksyen 78",

  [tokens.label.insituSamplingReport]: "Laporan Persampelan In situ",
  [tokens.label.serialNumber]: "No Siri",
  [tokens.label.enterSerialNumber]: "Masukkan no siri jika diberikan",
  [tokens.label.noticeDetails]: "Butiran Notis",
  [tokens.label.specifyDetails]: "Nyatakan butiran lanjut jika tidak dipatuhi",
  [tokens.msg.samplingDataInNextSection]:
    "Data persampelan akan diisi di bahagian seterusnya (Maklumat Persampelan)",
  [tokens.label.uploadFile]: "Muat Naik Fail",
  [tokens.label.remove]: "Buang",

  // Sampling Section
  [tokens.label.samplingInfo]: "Maklumat Pensampelan",
  [tokens.label.sampleCollected]: "Sampel Dikutip",
  [tokens.label.sampleId]: "ID Sampel",
  [tokens.label.collectionDateTime]: "Tarikh & Masa Pengumpulan",
  [tokens.label.waterQualityParameters]: "Parameter Kualiti Air",
  [tokens.label.dissolvedOxygen]: "Oksigen Terlarut (DO) mg/L",
  [tokens.label.biochemicalOxygenDemand]:
    "Permintaan Oksigen Biokimia (BOD) mg/L",
  [tokens.label.chemicalOxygenDemand]: "Permintaan Oksigen Kimia (COD) mg/L",
  [tokens.label.ammoniacalNitrogen]: "Nitrogen Ammonia (NH3-N) mg/L",
  [tokens.label.suspendedSolids]: "Jumlah Pepejal Terampai (TSS) mg/L",
  [tokens.label.phLevel]: "Tahap pH",
  [tokens.label.waterQualityIndex]: "Indeks Kualiti Air (IKA)",
  [tokens.label.wqiClass]: "Kelas IKA",
  [tokens.label.labReport]: "Laporan Makmal",
  [tokens.label.uploadLabReport]: "Muat Naik Laporan Makmal (Pilihan)",
  [tokens.label.labReportLatest]:
    "Laporan Analisis Makmal Terkini (< 6 bulan) - Pilihan",
  // Images Section
  [tokens.label.siteImages]: "Imej Tapak",
  [tokens.label.uploadImages]: "Muat Naik Imej",
  [tokens.label.maxImages]: "Maksimum 5 imej, maksimum saiz 3MB setiap satu",
  [tokens.label.imageCaption]: "Kapsyen Imej",

  // Summary Sections
  [tokens.label.observationsSummary]: "Rumusan & Ulasan Pemeriksaan",
  [tokens.label.recommendationsSummary]: "Tindakan Susulan / Pembetulan",
  [tokens.label.followUpActions]: "Pengesahan Tindakan yang Diambil",
  [tokens.label.maxCharacters]: "Maksimum 1000 aksara",
  [tokens.label.charactersRemaining]: "aksara berbaki",

  // Actions & Status
  [tokens.label.saveDraft]: "Simpan Draf",
  [tokens.label.continueEditing]: "Teruskan Mengedit",
  [tokens.label.submitReport]: "Hantar Laporan",
  [tokens.label.generatePDF]: "Jana PDF",
  [tokens.label.previewAndDownloadPDF]: "Pratonton dan Muat Turun PDF",
  [tokens.label.markAsCompleted]: "Tandakan Sebagai Selesai",
  [tokens.label.statusDraft]: "Draf",
  [tokens.label.statusCompleted]: "Selesai",
  [tokens.label.statusGenerated]: "Dijana",
  [tokens.label.lastSaved]: "Terakhir Disimpan",
  [tokens.label.autoSave]: "Auto-simpan diaktifkan",

  // Validation Messages
  [tokens.label.requiredField]: "Medan ini diperlukan",
  [tokens.label.invalidEmail]: "Alamat e-mel tidak sah",
  [tokens.label.invalidPhone]: "Nombor telefon tidak sah",
  [tokens.label.invalidCoordinates]: "Koordinat GPS tidak sah",
  [tokens.label.selectAtLeastOne]: "Sila pilih sekurang-kurangnya satu pilihan",
  [tokens.label.allParametersRequired]:
    "Semua parameter kualiti air diperlukan untuk pengiraan IKA",
  [tokens.label.pleaseFixRequiredFields]: "Sila isi medan wajib berikut:",
  [tokens.label.fileNumberRequired]: "No. Siri LSANK (Nombor Fail) diperlukan",
  [tokens.label.reportDateRequired]: "Tarikh laporan diperlukan",
  [tokens.label.inspectionDateRequired]: "Tarikh pemeriksaan diperlukan",
  [tokens.label.inspectionTimeRequired]: "Masa pemeriksaan diperlukan",
  [tokens.label.atLeastOneOfficerRequired]:
    "Sekurang-kurangnya seorang pegawai pemeriksaan diperlukan",
  [tokens.label.siteOfficerNameRequired]:
    "Nama pegawai tapak (PIC Tapak) diperlukan",
  [tokens.label.stationRequired]: "Stesen diperlukan",
  [tokens.label.sourcePointRequired]: "Titik sumber diperlukan",
  [tokens.label.addressLine1Required]: "Alamat Baris 1 diperlukan",
  [tokens.label.sampleIdRequiredWhenCollected]:
    "ID sampel diperlukan apabila sampel dikumpul",
  [tokens.label.sampleDateRequiredWhenCollected]:
    "Tarikh/masa pengumpulan sampel diperlukan apabila sampel dikumpul",
  [tokens.label.inspectionSummaryRequired]:
    "Rumusan & Ulasan Pemeriksaan diperlukan",
  [tokens.label.followUpActionsRequired]:
    "Tindakan Susulan/Pembetulan diperlukan",
  [tokens.label.actionConfirmationRequired]:
    "Pengesahan Tindakan yang Diambil diperlukan",
  [tokens.label.viewInspectionReports]: "Lihat Laporan Pemeriksaan",
  [tokens.label.inspectionReports]: "Laporan Pemeriksaan",
  [tokens.label.pdfGenerated]: "PDF berjaya dijana",
  [tokens.label.preview]: "Pratonton",
  [tokens.label.siteVisitDate]: "Tarikh Lawatan Tapak",
  [tokens.label.siteVisitTime]: "Masa Lawatan",
  [tokens.label.createdDate]: "Tarikh Dicipta",
  [tokens.label.officers]: "Pegawai",
  [tokens.label.activity]: "Aktiviti",
  [tokens.label.created]: "Dicipta",
  [tokens.label.updated]: "Dikemaskini",
  [tokens.label.reportType]: "Jenis Laporan",
};
